import { Paper } from "@mui/material";

const Background = (props: { children: JSX.Element | JSX.Element[] }) => (
    <Paper elevation={10} sx={{ width: "100%", padding: 3, borderRadius: 5 }}>
        {props.children}
    </Paper>
);

export default Background;
